import React from 'react';
import { formatDateTimeDisplayWithoutOffset } from "utils";

interface IDateWithTimeProps {
  date: string;
}

export const DateWithTime: React.FC<IDateWithTimeProps> = ({ date }) => {
  return (
    <p className="date font-pt-sans text-[13px] tracking-[0.52px] capitalize text-gray-100 m-0">
      {formatDateTimeDisplayWithoutOffset(date)}
    </p>
  );
};
